import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import CancelationBilling from "./cancelationBilling";
import ReportTemperature from "./reportTemperature";
import "./billingData.css";
import BillingShowData from "./billingShowData";
import Swal from "sweetalert2";
import CustomSelect from "../capture/custom-select";
import axios from "axios";

function BillingData() {
  const [selectFiveOptions, setSelectFiveOptions] = useState([]);
  const [view, setView] = useState("form");
  const [submitted, setSubmitted] = useState(false);
  const [activeView, setActiveView] = useState("billing");
  const [agents, setAgents] = useState([]);
  const [clients, setClients] = useState([]);

  const getAgents = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/agents`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setAgents(res.data.data);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
    }
  };

  const getClients = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/clients`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.status === 200) {
        setClients(res.data.body.pallets);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
    }
  };

  useEffect(() => {
    getAgents();
    getClients();
  }, []);

  const [formData, setFormData] = useState({
    agencia: "",
    cliente: "",
    usoCfdi: "",
    condicionesPago: "",
    metodoPago: "",
    cuentaPago: "",
    valorAduana: "",
    observaciones: "",
  });

  //Estados para cantidades y montos
  const [cantidades, setCantidades] = useState(Array(8).fill(0));
  const [flejeEmpaqueMonto, setFlejeEmpaqueMonto] = useState(0);
  const [subtotal, setSubtotal] = useState(305.0);
  const [iva, setIva] = useState(48.8);
  const [total, setTotal] = useState(353.8);

  const precioPorUnidad = 50;

  const handleFormChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleCantidadChange = (index, value) => {
    const updatedCantidades = [...cantidades];
    updatedCantidades[index] = Math.max(0, parseInt(value) || 0);
    setCantidades(updatedCantidades);
  };

  const handleCondicionesPagoChange = (e) => {
    const value = e.target.value;
    handleFormChange("condicionesPago", value);

    if (value === "opcion1") {
      setSelectFiveOptions(["Subopcion 1", "Subopcion 2"]);
    } else if (value === "opcion 2") {
      setSelectFiveOptions(["Subopcion A", "Subopcion B"]);
    } else {
      setSelectFiveOptions([]);
    }
  };

  useEffect(() => {
    const sumaCantidades = cantidades.reduce((acc, val) => acc + val, 0);
    const nuevoMontoFlejeEmpaque = sumaCantidades * precioPorUnidad;

    const nuevoSubtotal = 305.0 + nuevoMontoFlejeEmpaque;
    const nuevoIva = nuevoSubtotal * 0.16;
    const nuevoTotal = nuevoSubtotal + nuevoIva;

    setFlejeEmpaqueMonto(nuevoMontoFlejeEmpaque);
    setSubtotal(nuevoSubtotal);
    setIva(nuevoIva);
    setTotal(nuevoTotal);
  }, [cantidades]);

  if (view === "show") {
    return (
      <BillingShowData
        formData={formData}
        cantidades={cantidades}
        subtotal={subtotal}
        iva={iva}
        total={total}
      />
    );
  }

  const validarFormulario = () => {
    const camposRequeridos = [
      "agencia",
      "cliente",
      "usoCfdi",
      "condicionesPago",
      "metodoPago",
    ];

    for (const campo of camposRequeridos) {
      if (!formData[campo]) {
        return false;
      }
    }

    return true;
  };

  const facturaAlert = () => {
    Swal.fire({
      title: "Éxito",
      text: "Factura generada con éxito",
      icon: "success",
      iconColor: "#1B9925",
      customClass: {
        confirmButton: "btn-ok",
        title: "alert-title",
        popup: "alert-bg",
      },
    });
  };

  const handleGuardar = () => {
    setSubmitted(true);

    if (!validarFormulario()) {
      Swal.fire({
        title: "Campos incompletos",
        text: "Por favor completa todos los campos obligatorios antes de continuar.",
        icon: "warning",
        iconColor: "#FFA500",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    console.log("Datos del formulario:", formData);
    facturaAlert();
    setView("show");
  };

  //Condicional de renderizado de vistas
  let content = null;
  if (activeView === "billing") {
    if (view === "show") {
      content = (
        <BillingShowData
          formData={formData}
          cantidades={cantidades}
          subtotal={subtotal}
          iva={iva}
          total={total}
        />
      );
    } else {
      content = (
        <>
          {/* primer fila (solo se muestran los datos de la guia)*/}
          <div className="row">
            <div className="col-12 mt-4">
              <div className="row">
                {[
                  { label: "Master", value: "ABC123" },
                  { label: "Origen", value: "MEX" },
                  { label: "Destino", value: "MAD" },
                  { label: "Tipo de mercancía", value: "Perecedero" },
                  { label: "Piezas Master", value: "500" },
                  { label: "Peso Master", value: "100" },
                  { label: "HBS", value: "HBS1" },
                  { label: "Piezas House", value: "50" },
                  { label: "Peso House", value: "50" },
                ].map((item, index) => (
                  <div
                    key={index}
                    className={`pb-3 pb-md-5 ${
                      item.label === "Tipo de mercancía"
                        ? "col-md-3"
                        : "col-md-3"
                    }`}
                  >
                    <span className="fw-bold">{item.label}: </span>
                    {item.value}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* segunda fila que tienen 5 selects, 3 inputs*/}
          <div className="row mb-4">
            <div className="col-md-3 mb-3">
              <label className="fw-bold">Agencia aduanal o Almacén *</label>
              <CustomSelect
                label=""
                options={agents}
                labelKey="name"
                value={agents.find((a) => a.name === formData.agencia) || null}
                onSelect={(selected) =>
                  handleFormChange("agencia", selected ? selected.name : "")
                }
              />
              {submitted && !formData.agencia && (
                <div className="invalid-feedback d-block">Campo requerido</div>
              )}
            </div>
            <div className="col-md-3 mb-3">
              <label className="fw-bold">Clientes *</label>
              <CustomSelect
                label=""
                options={clients}
                labelKey="name"
                value={clients.find((c) => c.name === formData.cliente) || null}
                onSelect={(selected) =>
                  handleFormChange("cliente", selected ? selected.name : "")
                }
              />
              {submitted && !formData.cliente && (
                <div className="invalid-feedback d-block">Campo requerido</div>
              )}
            </div>
            <div className="col-md-3 mb-3">
              <label className="fw-bold">Uso del CFDI *</label>
              <select
                className={`form-select ${
                  submitted && !formData.usoCfdi ? "is-invalid" : ""
                }`}
                value={formData.usoCfdi}
                onChange={(e) => handleFormChange("usoCfdi", e.target.value)}
              >
                <option value="" disabled>
                  Selecciona...
                </option>
                <option value="opM">Opción M</option>
                <option value="opN">Opción N</option>
              </select>
              {submitted && !formData.usoCfdi && (
                <div className="invalid-feedback">Campo requerido</div>
              )}
            </div>
            <div className="col-md-3 mb-3">
              <label className="fw-bold">Condiciones de pago *</label>
              <select
                className={`form-select ${
                  submitted && !formData.condicionesPago ? "is-invalid" : ""
                }`}
                value={formData.condicionesPago}
                onChange={handleCondicionesPagoChange}
              >
                <option value="" disabled>
                  Selecciona...
                </option>
                <option value="opcion1">Opción 1</option>
                <option value="opcion2">Opción 2</option>
              </select>
              {submitted && !formData.condicionesPago && (
                <div className="invalid-feedback">Campo requerido</div>
              )}
            </div>
            <div className="col-md-3 mb-3">
              <label className="fw-bold">Métodos de pago *</label>
              <select
                className={`form-select ${
                  submitted && !formData.metodoPago ? "is-invalid" : ""
                }`}
                value={formData.metodoPago}
                onChange={(e) => handleFormChange("metodoPago", e.target.value)}
                disabled={!selectFiveOptions.length}
              >
                <option value="" disabled>
                  Selecciona...
                </option>
                {selectFiveOptions.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {submitted && !formData.metodoPago && (
                <div className="invalid-feedback">Campo requerido</div>
              )}
            </div>
            <div className="col-md-3">
              <label className="fw-bold">Cuenta pago</label>
              <input
                type="text"
                className={`form-control ${
                  submitted && !formData.cuentaPago ? "is-invalid" : ""
                }`}
                value={formData.cuentaPago}
                onChange={(e) => handleFormChange("cuentaPago", e.target.value)}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9.]/g, "")
                    .replace(/(\..*)\./g, "$1");
                }}
              />
              {submitted && !formData.cuentaPago && (
                <div className="invalid-feedback">Campo requerido</div>
              )}
            </div>
            <div className="col-md-3 mt-3 mt-md-0">
              <label className="fw-bold">Valor aduana</label>
              <input
                type="number"
                inputMode="decimal"
                className={`form-control ${
                  submitted && !formData.valorAduana ? "is-invalid" : ""
                }`}
                value={formData.valorAduana}
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "Tab",
                    "ArrowLeft",
                    "ArrowRight",
                    "Delete",
                    ".", // navegación y edición
                  ];
                  const isNumber = /^[0-9]$/.test(e.key);

                  if (!isNumber && !allowedKeys.includes(e.key)) {
                    e.preventDefault();
                  }

                  // Evita múltiples puntos
                  if (e.key === "." && e.currentTarget.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  const floatRegex = /^\d*\.?\d*$/;

                  if (value === "" || floatRegex.test(value)) {
                    handleFormChange("valorAduana", value);
                  }
                }}
                placeholder="0.00"
              />
              {submitted && !formData.valorAduana && (
                <div className="invalid-feedback">Campo requerido</div>
              )}
            </div>

            <div className="col-md-3 mt-3 mt-md-0">
              <label className="fw-bold">Observaciones</label>
              <input
                type="text"
                className={`form-control ${
                  submitted && !formData.observaciones ? "is-invalid" : ""
                }`}
                value={formData.observaciones}
                onChange={(e) =>
                  handleFormChange("observaciones", e.target.value)
                }
              />
              {submitted && !formData.observaciones && (
                <div className="invalid-feedback">Campo requerido</div>
              )}
            </div>
          </div>

          {/* tercer fila con 2 tablas*/}
          <div className="row mb-4">
            <div className="col-md-6 text-center">
              <table className="table fondo-headBilling">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    "Fleje skid 1.60 cm",
                    "Fleje skid medio",
                    "Fleje pza suelta",
                    "Vitafilm skid 1.60 cm",
                    "Vitafilm skid medio",
                    "Vitafilm pza suelta",
                    "Suministro Tarima Std",
                    "Suministro Tarima Eur",
                  ].map((nombre, i) => (
                    <tr key={i}>
                      <td>{nombre}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control text-center"
                          value={cantidades[i]}
                          onChange={(e) =>
                            handleCantidadChange(i, e.target.value)
                          }
                          min="0"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="col-md-6 text-center">
              <table className="table fondo-headBilling">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th>Monto</th>
                    <th>Excepción</th>
                    <th>Reglas C.</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { concepto: "Manejo de carga", monto: "259.50" },
                    { concepto: "Refrigeración", monto: "0.00" },
                    { concepto: "Congelación", monto: "0.00" },
                    { concepto: "Screening", monto: "45.50" },
                    { concepto: "DG Fee", monto: "0.00" },
                    { concepto: "Manejo por valor", monto: "0.00" },
                    {
                      concepto: "Fleje y empaque",
                      monto: flejeEmpaqueMonto.toFixed(2),
                    },
                    { concepto: "Animales vivos", monto: "0.00" },
                    { concepto: "DG exentas", monto: "0.00" },
                    { concepto: "Hielo seco", monto: "0.00" },
                    { concepto: "Cont. Activos (RKN)", monto: "0.00" },
                    { concepto: "Cont. Activos (RAP)", monto: "0.00" },
                    { concepto: "Preparación de cont. (RKN)", monto: "0.00" },
                    { concepto: "Preparación de cont. (RAP)", monto: "0.00" },
                  ].map((item, i) => (
                    <tr key={i}>
                      <td>{item.concepto}</td>
                      <td>{item.monto}</td>
                      <td>N/A</td>
                      <td>N/A</td>
                    </tr>
                  ))}
                  <tr className="bor-bot">
                    <td className="text-center fw-bold">Subtotal</td>
                    <td className="text-center">{subtotal.toFixed(2)}</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td className="text-center fw-bold">IVA 16%</td>
                    <td className="text-center">{iva.toFixed(2)}</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td className="text-center fw-bold">Total</td>
                    <td className="text-center">{total.toFixed(2)}</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="row">
            <div className="btns mt-3 d-flex justify-content-end gap-3">
              <button className="btnn" onClick={handleGuardar}>
                Generar Factura
              </button>
            </div>
          </div>
        </>
      );
    }
  } else if (activeView === "cancelation") {
    content = <CancelationBilling />;
  } else if (activeView === "temperature") {
    content = <ReportTemperature />;
  }

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        {/* Botones para cambiar de vistas del modulo Facturación */}
        <div className="d-flex gap-3 mb-4">
          <button
            className="btnn"
            style={{
              backgroundColor: activeView === "billing" ? "" : "#e0e0e0",
            }}
            onClick={() => setActiveView("billing")}
          >
            Facturación
          </button>
          <button
            className="btnn"
            style={{
              backgroundColor: activeView === "cancelation" ? "" : "#e0e0e0",
            }}
            onClick={() => setActiveView("cancelation")}
          >
            Facturas de cancelación
          </button>
          <button
            className="btnn"
            style={{
              backgroundColor: activeView === "temperature" ? "" : "#e0e0e0",
            }}
            onClick={() => setActiveView("temperature")}
          >
            Reporte de temp.
          </button>
        </div>

        {content}
      </div>
    </>
  );
}

export default BillingData;
